module.exports = __webpack_public_path__ + "img/decor.58dd24ad.jpg";